import React from 'react'

const Pencil = ({ color }) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9606 4.68605C17.145 2.8274 15.2674 0.91185 13.3519 0.0583868C13.1053 -0.0554083 12.8019 0.00148926 12.6122 0.191148L1.59306 11.2103C1.49823 11.3051 1.44133 11.4 1.42236 11.5327L0.0188909 17.1845C-0.0380067 17.4121 0.0378567 17.6587 0.189583 17.8104C0.34131 17.9621 0.587866 18.038 0.815456 17.9811L6.46728 16.5966C6.58107 16.5587 6.69487 16.5018 6.7897 16.4259L17.7899 5.42572C18.0175 5.23606 18.0744 4.93261 17.9606 4.68605ZM10.9053 3.79466L12.1001 4.98951L4.96898 12.1017C4.53276 11.7224 4.07758 11.381 3.60344 11.0965L10.9053 3.79466ZM3.28102 16.0087C2.99653 15.4776 2.56031 15.0224 2.0103 14.719L2.65514 12.0827C3.96379 12.8034 5.2345 14.0741 5.91727 15.3638L3.28102 16.0087ZM6.92246 14.4155C6.63797 13.9414 6.29658 13.4862 5.91727 13.05L13.0295 5.9378L14.2053 7.11368L6.92246 14.4155ZM15.1726 6.16539L11.8536 2.84637L13.2191 1.48082C14.5467 2.18256 15.8554 3.51017 16.5381 4.81881L15.1726 6.16539Z"
        fill={color}
      />
    </svg>
  )
}

export default Pencil
